import React from "react";
import { ModalContainer } from "./modalContainer";
import PDFviewer from "../components/PDFviewer/pdfViewer";
import AttachmentVideo from "../components/AttachmentVideo";
import { getFileExtension, isImageFile, isPdfFile, isVideoFile } from "../utils/mediaTypes";


export default function PreviewAttachment(props) {
    const { currentProps, defaultProps } = props;
    const { title, attachment } = currentProps;
    const fileType = getFileExtension(attachment.fileid);

    if (isImageFile(attachment.fileid)) {
        return (
            <ModalContainer title={title} {...defaultProps}>
                <div className="container">
                    <img src={attachment.location} className="img-fluid" alt="Attachment Preview" />
                </div>
            </ModalContainer>
        )
    }

    if (isVideoFile(attachment.fileid)) {
        return (
            <ModalContainer title={title} {...defaultProps}>
                <div className="container">
                    <AttachmentVideo src={attachment.location} filename={attachment.fileid} />
                </div>
            </ModalContainer>
        )
    }

    if (isPdfFile(attachment.fileid) || fileType === 'csv') {
        return (
            <ModalContainer title={title} {...defaultProps}>
                <PDFviewer fileName={attachment.fileid} url={attachment.location} />
            </ModalContainer>
        )
    }

    return (
        <ModalContainer title={title} {...defaultProps}>
            <div className="container">
                <ModuleiFrame module={attachment} />
            </div>
        </ModalContainer>
    )
}

function ModuleiFrame(props){
    let {module} = props
    return(
      <div className="module-iframe">
        <iframe
          src={module.location}
          key={module.fileid}
          view="Fit"
          aria-label={`${module.fileid}-pdf-img`}
          allowFullScreen
        />
      </div>
    )
}
